module.exports = __webpack_public_path__ + "img/quick_quotes_quill.3a7bda71.jpg";